import EndpointsUserManagementRoleGroup from './role-group.router';
import EndpointsUserManagementUser from './user';

const EndpointsUserManagement = {
  ...EndpointsUserManagementRoleGroup,
  ...EndpointsUserManagementUser,
};

export default EndpointsUserManagement;
